"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = void 0;
var React = require("react");
require("./style.scss");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var meterEntryRemarkActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/remark");
var meterEntriesActions = require("@caddigital/sok-reducers/lib/actions/trmvrmeterentries/list");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var sok_ui_1 = require("@caddigital/sok-ui");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var components_1 = require("components");
var classNames = require("classnames");
var viewport_1 = require("reducers/viewport");
var text_1 = require("utils/text");
var moment = require("moment-timezone");
var search_1 = require("utils/search");
var ColumnFilter_1 = require("components/ColumnFilter");
var RemarkModal_1 = require("./Modal/RemarkModal");
var UploadModal_1 = require("./Modal/UploadModal");
var options_1 = require("./Modal/options");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var sort_1 = require("utils/sort");
var filter_1 = require("utils/filter");
var SortButton = sok_ui_1.Table.SortButton;
var headers = [
    'created_at',
    'entry_date',
    'target',
    'remark',
    'responsible_company',
    'must_be_fixed_at',
    'remark_status',
    'confirmed_at',
    'confirmed_by'
];
var mobileHeaders = [
    'created_at',
    'remark_status'
];
var sortObjects = (0, sort_1.getSortFunction)({
    dateFields: ['created_at', 'must_be_fixed_at', 'confirmed_at', 'entry_dat'],
    userNameFields: ['confirmed_by'],
    textFields: ['target', 'remark', 'responsible_company', 'remark_status']
});
var mapStateToProps = function (state, ownProps) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        list: state.trmvrmeterentries.list, // for sorting / filtering
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        remark: state.trmvrmeterentries.remark,
        selectedLanguage: selectedLanguage,
        user: state.auth.current.user,
        currentRemark: state.trmvrmeterentries.remark.currentRemark,
        showUploadModal: state.trmeterRemarkImages.modalState.isOpen
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchRemarks: function (meterUuid) {
        return dispatch(meterEntryRemarkActions.fetchAllRequest(meterUuid));
    },
    fetchRemark: function (remarkUuid, meterUuid, entryUuid) {
        return dispatch(meterEntryRemarkActions.fetchRemarkRequest(remarkUuid, meterUuid, entryUuid));
    },
    updateRemark: function (payload) { return dispatch(meterEntryRemarkActions.updateRemarkRequest(payload)); },
    clearState: function () { return meterEntryRemarkActions.clear(); },
    addNewToast: function (title, message, type) {
        return dispatch(toastActions.addNewToast(title, message, type));
    },
    setPaginationOptions: function (offset, limit) {
        return dispatch(meterEntriesActions.setPaginationOptions(offset, limit));
    },
    setColumnFilter: function (field, value) {
        return dispatch(meterEntriesActions.setColumnFilter(field, value));
    },
    setOrderBy: function (orderBy, order) {
        return dispatch(meterEntriesActions.setOrderBy(orderBy, order));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var getColumn = function (column, value, link) {
    return (React.createElement("div", { className: classNames("row__column dynamic __".concat(column), column === 'name' && 'expand'), "data-key": "__".concat(column) }, value));
};
var getUserName = function (user) {
    if (user) {
        return user.firstName + ' ' + user.lastName;
    }
    else
        return '';
};
var getTargetLocalization = function (remark) {
    return "".concat(remark.target, " ").concat(remark.meter_type === 'TRMETER'
        ? (0, options_1.findNameWithId)(remark.target, options_1.targetOptions)
        : (0, options_1.findNameWithId)(remark.target, options_1.targetOptionsMvr));
};
var getRemarkLocalization = function (remark) {
    return "".concat(remark.remark, " ").concat(remark.meter_type === 'TRMETER'
        ? (0, options_1.findRemarkWithTarget)(remark.remark, remark.target)
        : (0, options_1.findRemarkWithTargetMvr)(remark.remark, remark.target));
};
var ListRow = function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var isMobile = data.isMobile, remarks = data.remarks, fetchRemark = data.fetchRemark, setRemarkModal = data.setRemarkModal, setRemarkUuid = data.setRemarkUuid, currentTRMVRMeter = data.currentTRMVRMeter;
    var row = remarks[index];
    var handleRemarkModal = function (remarkUuid, meterUuid, entryUuid) {
        fetchRemark(remarkUuid, meterUuid, entryUuid);
        setRemarkUuid(remarkUuid);
        setRemarkModal(true);
    };
    return (React.createElement("div", { className: classNames('row remark-row'), style: style, onClick: function () {
            return handleRemarkModal(row.uuid, currentTRMVRMeter.trmvrmeter_uuid, row.entry_uuid);
        } },
        React.createElement("div", { className: "row__column narrow select-remark", key: 'select-remark' },
            React.createElement(components_1.TableRowIcon, { icon: 'fas fa-bullseye-pointer' }),
            React.createElement("div", { className: "row__column narrow" })),
        React.createElement("div", { className: 'row__column mobile' }, getColumn('created_at', moment(new Date(row.created_at)).format('L'))),
        getColumn('entry_date', moment(new Date(row.entry_date)).format('L')),
        getColumn('target', getTargetLocalization(row)),
        getColumn('remark', getRemarkLocalization(row)),
        getColumn('responsible_company', row.responsible_company),
        getColumn('must_be_fixed_at', moment(new Date(row.must_be_fixed_at)).format('L')),
        getColumn('remark_status', (0, translation_1.getLocalization)("trmvrmeterRemarksView/values/".concat(row.remark_status))),
        getColumn('confirmed_at', row.confirmed_at ? moment(new Date(row.confirmed_at)).format('L') : ''),
        getColumn('confirmed_by', getUserName(row.confirmed_by)),
        React.createElement("div", { className: "row__column narrow" })));
};
var getOptions = function (identifier) {
    if (identifier === 'remark_status') {
        return [
            {
                key: 'pending',
                value: (0, translation_1.getLocalization)("trmvrmeterEntryView/values/pending")
            },
            {
                key: 'complete',
                value: (0, translation_1.getLocalization)("trmvrmeterEntryView/values/complete")
            }
        ];
    }
};
var getHeaderColumn = function (props, name, identifier) {
    var order = props.list.orderByOptions.orderBy === identifier &&
        props.list.orderByOptions.order === 'asc'
        ? 'desc'
        : 'asc';
    var enabled = true;
    var dataKey = '__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column dynamic trmvrmeter-entries-list-row-column', dataKey) },
        React.createElement("div", { onClick: function () {
                props.setOrderBy(identifier, order);
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }, (0, translation_1.getLocalization)("trmvrmeterRemarksView/column/".concat(name))),
        React.createElement(SortButton, { className: "d-none d-desktop-table-cell filter", order: props.list.orderByOptions.orderBy === identifier
                ? props.list.orderByOptions.order.toLowerCase()
                : null, disabled: !enabled, onChange: function () {
                props.setOrderBy(identifier, order);
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: props.list.filterOptions && props.list.filterOptions[identifier]
                ? 'active filter'
                : '' + ' filter', columnIdentifier: identifier, textInputValue: props.list.filterOptions && props.list.filterOptions[identifier]
                ? props.list.filterOptions[identifier] || ''
                : '', inputType: (function () {
                switch (identifier) {
                    case 'remark_status':
                        return 'radiobutton';
                    default:
                        return 'text';
                }
            })(), options: getOptions(identifier), setColumnFilterString: function (field, value) {
                props.setColumnFilter(field, value);
                var params = __assign({}, props.queryParams);
                params[field] = value;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            }, clearColumnFilter: function (field) {
                props.setColumnFilter(field, undefined);
                var params = __assign({}, props.queryParams);
                params[field] = undefined;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } })));
};
var enhanceHeader = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    return nextProps.isMobile !== props.isMobile ||
        (0, List_1.shallowDiffers)(nextProps.style, props.style) ||
        (0, List_1.shallowDiffers)(nextProps.list.orderByOptions, props.list.orderByOptions) ||
        (0, List_1.shallowDiffers)(props.list.filterOptions, nextProps.list.filterOptions);
}));
var Header = enhanceHeader(function (props) {
    var shownHeaders = headers;
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column first narrow icon" }),
        getHeaderColumn(props, 'created_at', 'created_at'),
        shownHeaders
            .filter(function (x) { return x !== 'created_at' && x !== 'uuid'; })
            .map(function (header) { return getHeaderColumn(props, header, header); }),
        React.createElement("div", { className: "row__column narrow" })));
});
var filterNormalizers = {
    targets: {
        fields: ['target'],
        fn: function (key, item) { return getTargetLocalization(item); }
    },
    remarks: {
        fields: ['remark'],
        fn: function (key, item) { return getRemarkLocalization(item); }
    },
    dates: {
        fields: ['created_at', 'must_be_fixed_at', 'confirmed_at', 'entry_date'],
        fn: function (key, item) {
            return moment(new Date(item[key])).format('L');
        }
    },
    userNames: {
        fields: ['confirmed_by'],
        fn: function (key, item) {
            return getUserName(item.confirmed_by);
        }
    }
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.withState)('showRemark', 'setShowRemark', false), (0, recompose_1.withState)('remarkUuid', 'setRemarkUuid', ''), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        if (this.props.currentTRMVRMeter) {
            this.props.fetchRemarks(this.props.currentTRMVRMeter.trmvrmeter_uuid);
        }
    },
    componentDidUpdate: function (prevProps) {
        var items = this.props.remark.remarks;
        if (this.props.list.searchString !== prevProps.list.searchString ||
            this.props.list.orderByOptions !== prevProps.list.orderByOptions ||
            this.props.list.filterOptions !== prevProps.list.filterOptions ||
            this.props.list.offset !== prevProps.list.offset ||
            this.props.list.limit !== prevProps.list.limit ||
            (prevProps.remark.remarks.length === 0 &&
                this.props.remark.remarks.length) ||
            this.props.remark.remarks !== prevProps.remark.remarks ||
            (prevProps.remark.status !== 'FETCHED' &&
                this.props.remark.status === 'FETCHED')) {
            var orderBy = this.props.list.orderByOptions.orderBy;
            var order = this.props.list.orderByOptions.order;
            var remarks = this.props.remark.remarks;
            var filteredData = (0, filter_1.filterObjectList)(remarks, {
                filters: this.props.list.filterOptions,
                normalizers: filterNormalizers
            }, this.props.list.searchString);
            var data = sortObjects(filteredData, {
                sortBy: orderBy,
                sortOrder: order
            });
            items = data.slice(Math.max(0, Math.min(data.length, this.props.list.offset)), Math.min(this.props.list.offset + this.props.list.limit, data.length));
            this.props.setTotal(data.length);
            this.props.setItems(items);
        }
        if (this.props.remark.remarks !== prevProps.remark.remarks ||
            this.props.isMobile !== prevProps.isMobile) {
            var contentWidth_1 = 0;
            var columns_1 = this.props.remark.remarks.reduce(function (p, item) {
                Object.keys(item).forEach(function (c) {
                    if (!headers.includes(c)) {
                        return;
                    }
                    var dataKey = '__' + c.replace(/-/g, '');
                    var text = (function (v, c, r) {
                        if (c === 'created_at' ||
                            c === 'entry_date' ||
                            c === 'responsible_company' ||
                            c === 'must_be_fixed_at' ||
                            c === 'remark_status' ||
                            c === 'confirmed_at' ||
                            c === 'confirmed_by') {
                            return v.toString();
                        }
                        else if (c === 'target') {
                            return getTargetLocalization(r);
                        }
                        else if (c === 'remark') {
                            return getRemarkLocalization(r);
                        }
                        return v;
                    })((item[c] || '').toString(), c, item);
                    var length = (0, text_1.calculateStringLength)(text);
                    var prevValue = p[dataKey];
                    if (prevValue && prevValue.length < length) {
                        prevValue.text = text;
                        prevValue.length = length;
                    }
                    else if (!prevValue) {
                        p[dataKey] = {
                            text: text,
                            length: length
                        };
                    }
                });
                return p;
            }, {});
            var shownHeaders = headers;
            shownHeaders.forEach(function (x) {
                var dataKey = '__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("trmvrmeterRemarksView/column/".concat(x)).toString();
                var length = (0, text_1.calculateStringLength)(text) + 42;
                var prevValue = columns_1[dataKey];
                if (prevValue && prevValue.length < length) {
                    prevValue.text = text;
                    prevValue.length = length;
                }
                else if (!prevValue) {
                    columns_1[dataKey] = {
                        text: text,
                        length: length
                    };
                }
            });
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x].length;
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('RemarksListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'RemarksListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 2 * 42;
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    },
    componentWillUnmount: function () {
        var _this = this;
        this.props.clearState();
        headers.forEach(function (header) {
            _this.props.setColumnFilter(header, undefined);
        });
    }
}), recompose_1.pure);
exports.ListContainer = enhance(function (props) {
    var _a = React.useState(), uploadFolder = _a[0], setUploadFolder = _a[1];
    var itemData = {
        style: {},
        isMobile: props.isMobile,
        remarks: props.items,
        fetchRemark: props.fetchRemark,
        setRemarkModal: props.setShowRemark,
        setRemarkUuid: props.setRemarkUuid,
        currentTRMVRMeter: props.currentTRMVRMeter
    };
    function editRemark(remark, remarkUuid) {
        if (props.currentRemark &&
            props.currentRemark.entry_uuid &&
            props.currentTRMVRMeter &&
            props.currentTRMVRMeter.trmvrmeter_uuid &&
            props.currentRemark.meter_type) {
            var payload = {
                remark: remark,
                remarkUuid: remarkUuid,
                meterUuid: props.currentTRMVRMeter.trmvrmeter_uuid,
                entryUuid: props.currentRemark.entry_uuid
            };
            props.updateRemark(payload);
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'trmvrmeter-entries-list-view-list-container' },
            React.createElement("div", { className: 'sok-list-content trmvrmeter-entries-list-view-list' +
                    props.remark.status.toLowerCase() },
                props.remark.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                            if (props.currentTRMVRMeter) {
                                {
                                    props.fetchRemarks(props.currentTRMVRMeter.trmvrmeter_uuid);
                                }
                            }
                        } }))),
                ((!props.remark.remarks && props.remark.status === 'FETCHING') ||
                    props.remark.status === 'STANDBY') && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.remark.remarks &&
                    props.remark.status !== 'FAILED' &&
                    props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props)), placeholder: React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { className: 'no-remarks', title: 'trmvrmeterRemarksView/emptyList/title', message: 'trmvrmeterRemarksView/emptyList/message', key: 'no-remarks' }) }, ListRow));
                })))),
        props.showRemark && (React.createElement(RemarkModal_1.default, __assign({}, props, { perm: props.currentProject && props.currentProject.perm
                ? props.currentProject.perm
                : 0x00, isTRMeter: props.currentTRMVRMeter &&
                props.currentTRMVRMeter.meterType === 'TRMETER'
                ? true
                : false, closeModal: function () { return props.setShowRemark(false); }, show: props.showRemark && !props.showUploadModal, saveFunction: editRemark, setUploadFolder: setUploadFolder }))),
        uploadFolder && (React.createElement(UploadModal_1.default, { folder: uploadFolder, multipleFiles: true, uploadButtonLabel: "sokosite/trmeter/remark/upload", descriptionLabel: "sokosite/trmeter/remark/uploadDescription", accept: 'image/png, image/gif, image/jpeg' })),
        React.createElement(sok_ui_1.Pagination, { key: 'pagination', limit: props.list.limit, total: props.total, limitOptions: props.list.itemsPerPage, offset: props.list.offset, updatePageState: function (offset, limit) {
                props.setPaginationOptions(offset, limit);
                props.updateUrl(props.pathname +
                    (0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { offset: offset, limit: limit })));
            } })));
});
